import React from "react";
import "./Navbar.css";

export default function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo-container">
        <img src="/assets/logo.png" alt="Synthera Logo" className="logo-img" />
      </div>
      <ul className="nav-links">
        <li><a href="/">Home</a></li>
        <li><a href="/try">MVP</a></li>
        <li><a href="#about">About</a></li>
      </ul>
      <a href="/try" className="cta-btn">Try MVP</a>
    </nav>
  );
}
